import { Box, useMediaQuery } from "@mui/material";
import { Parallax, ParallaxLayer } from "@react-spring/parallax";
import React, { useMemo } from "react";
import { useSubscribeModal } from "../../../../state/hooks";
import { useScopedDowngradedStateValue } from "../../../hooks/utils/useScopedDowngradedStateValue";
import {
  CLIENT_MOBILE_VIEW_CONFIG,
  MOBILE_MIN_HEIGHT,
  MOBILE_NAVBAR_HEIGHT,
  SMALL_MOBILE_NAVBAR_HEIGHT,
} from "../../constants";
import { CurrentPageContent } from "../../CurrentPageContent";
import { useScrollEffects } from "../../hooks";
import { Topbar } from "../../Topbar";
import { LandingStepA } from "../steps";
import { AccountTypeSwitch } from "./AccountTypeSwitch";
import {
  clientDesktopPages,
  clientMobilePages,
} from "./ClientLargeViewParallax";

export const ClientSmallViewParallax = () => {
  const { backgroundColors, pagesCount } = CLIENT_MOBILE_VIEW_CONFIG;
  const smallMobileHeight = useMediaQuery("(max-height: 400px)", {
    noSsr: true,
  });
  const subscribeDialog = useScopedDowngradedStateValue(useSubscribeModal());
  const smallWidthView = useMediaQuery("(max-width: 600px)");

  const { isScrolling, currentVisibleView, lastVisitedView } = useScrollEffects(
    {
      pagesCount,
      backgroundColors,
    }
  );

  const height = useMemo(() => {
    if (smallMobileHeight) return SMALL_MOBILE_NAVBAR_HEIGHT;

    return MOBILE_NAVBAR_HEIGHT;
  }, [smallMobileHeight]);

  return (
    <Box height="100%" width="100%">
      <Topbar
        height={height * (isScrolling || subscribeDialog.open ? 0.8 : 1)}
        inverse
        color="#F5895F"
        containerProps={{
          top: 0,
          position: "fixed",
        }}
      />
      <Parallax
        className={`parallax-container`}
        style={{
          backgroundColor: "#B1D9D9",
        }}
        pages={pagesCount}
      >
        <ParallaxLayer
          style={{
            minHeight: MOBILE_MIN_HEIGHT,
          }}
        >
          <LandingStepA />
          <AccountTypeSwitch defaultChecked="client" />
        </ParallaxLayer>
        <ParallaxLayer
          sticky={{
            start: 1,
            end: pagesCount - 2,
          }}
          style={{
            display: "flex",
            minHeight: MOBILE_MIN_HEIGHT,
          }}
        >
          <CurrentPageContent
            mobilePages={clientMobilePages}
            desktopPages={clientDesktopPages}
            currentPage={currentVisibleView}
            previousPage={lastVisitedView}
          >
            {!smallWidthView && <AccountTypeSwitch defaultChecked="client" />}
          </CurrentPageContent>
        </ParallaxLayer>
        <ParallaxLayer
          offset={pagesCount - 1}
          style={{
            minHeight: MOBILE_MIN_HEIGHT,
          }}
        >
          <LandingStepA />
        </ParallaxLayer>
      </Parallax>
    </Box>
  );
};
